export const SidebarActionTypes = {
  SET: {
    STATE_SIDEBAR: "SET_STATE_SIDEBAR",
    OPEN_SIDEBAR: "SET_OPEN_SIDEBAR",
  },
};
